export function resolveRouteAccess(matchedMeta, userType, fullPath) {
  const hasMeta = (key) => matchedMeta.some((meta) => meta && meta[key]);
  const authRequired = hasMeta("authRequired");

  if (authRequired) {
    if (userType === null || userType === undefined) {
      return {
        name: "login",
        params: { userType: "customer", nextUrl: fullPath },
      };
    }

    if (
      hasMeta("isCustomer") &&
      (userType === 2 || userType === 3) &&
      !hasMeta("isSuperClient")
    ) {
      return null;
    }
    if (hasMeta("isSuperClient") && userType === 3) return null;
    if (hasMeta("isPublisher") && userType === 1) return null;
    if (hasMeta("isUser")) return null;

    if (userType === 2 || userType === 3) {
      return {
        name: "publications",
        params: { type: "paper" },
      };
    }
    return { name: "publisherHomePage" };
  }

  if (userType === 1) return { name: "publisherHomePage" };
  if (userType !== null && userType !== undefined) {
    return {
      name: "publications",
      params: { type: "paper" },
    };
  }
  return null;
}
